import { TContactInitialState, TContactActionTypes } from './types';
import { updateContactState } from './utils';
import {
    DEFAULT_CONTACT_STATE,
    CREATE_CONTACT,
    GET_CONTACT,
    GET_CONTACTS,
    UPDATE_CONTACT,
    CLEAR_CONTACT,
} from './constants';
import { CLEAR_STATE, DELETE_CONTACT, SET_ERROR, SET_LOADING } from '../types';

export default (
    state: TContactInitialState,
    action: TContactActionTypes
): TContactInitialState => {
    switch (action.type) {
        case CLEAR_CONTACT:
            return updateContactState(state, action.payload);

        case CLEAR_STATE:
            return updateContactState(state, DEFAULT_CONTACT_STATE);
        case CREATE_CONTACT:
            return updateContactState(state, {
                contacts: [action.payload, ...state.contacts],
                loading: false,
                error: null,
            });
        case UPDATE_CONTACT:
            const isContactInState = state.contacts.some(
                (contact) => contact._id === action.payload._id
            );

            if (isContactInState) {
                return updateContactState(state, {
                    contacts: state.contacts.map((contact) =>
                        contact._id === action.payload._id
                            ? action.payload
                            : contact
                    ),
                    contact: action.payload,
                    loading: false,
                    error: null,
                });
            }

            return updateContactState(state, {
                contacts: [...state.contacts, action.payload],
                contact: action.payload,
                loading: false,
                error: null,
            });
        case GET_CONTACT:
            return updateContactState(state, {
                contact: action.payload,
                loading: false,
                error: null,
            });
        case GET_CONTACTS:
            return updateContactState(state, {
                contacts: action.payload.contacts,
                total: action.payload.total,
                loadingContactList: false,
                error: null,
            });
        case SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        case SET_LOADING: {
            if (action.field)
                return updateContactState(state, {
                    [action.field]: true,
                });
            else
                return updateContactState(state, {
                    loading: true,
                });
        }
        case DELETE_CONTACT:
            return updateContactState(state, {
                loading: false,
            });
        default:
            return state;
    }
};
